import { JSX, createContext, useContext, useState } from "react";

interface EnableRequestQuoteCtxType {
  enableRequestQuote: boolean;
  setEnableRequestQuote: (enableRequestQuote: boolean) => void;
}

export const EnableRequestQuoteCtx = createContext<EnableRequestQuoteCtxType>({
  enableRequestQuote: false,
  setEnableRequestQuote: () => {
    console.error(
      "setEnableRequestQuote in EnableRequestQuoteCtx is not defined, check if you have set up the contextProvider",
    );
  },
});

export function RequestQuoteProvider({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element {
  const [enableRequestQuote, setEnableRequestQuote] = useState(false);
  return (
    <EnableRequestQuoteCtx.Provider
      value={{ enableRequestQuote, setEnableRequestQuote }}
    >
      {children}
    </EnableRequestQuoteCtx.Provider>
  );
}

export function useRequestQuote(): EnableRequestQuoteCtxType {
  return useContext(EnableRequestQuoteCtx);
}
